import { Avatar } from '@repletoryreach/sdk-ui';

/**
 * The contact's avatar with a channel badge on it.
 *
 * The reference design marks every row and every thread header with the
 * channel the conversation arrived on. There is only WhatsApp today, but the
 * badge is worth having now: `phone_numbers` is per-channel and the inbox
 * already carries `phone_number_id`, so a second channel would otherwise
 * arrive with nothing on screen to tell the two apart.
 */
export function ContactAvatar({ name, size = 40 }: { name: string; size?: number }) {
  return (
    <span className="rr-inbox2__avatar" style={{ width: size, height: size }}>
      <Avatar name={name} size={size} />
      <span className="rr-inbox2__avatar-channel" aria-hidden>
        <WhatsAppGlyph size={Math.round(size * 0.42)} />
      </span>
    </span>
  );
}

/** The WhatsApp mark, drawn rather than fetched: no network, and it themes. */
export function WhatsAppGlyph({ size = 12 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden focusable="false">
      <path d="M12.04 2C6.58 2 2.13 6.45 2.13 11.91c0 1.75.46 3.45 1.32 4.95L2 22l5.25-1.38a9.9 9.9 0 0 0 4.79 1.22h.01c5.46 0 9.91-4.45 9.91-9.91 0-2.65-1.03-5.14-2.9-7.01A9.82 9.82 0 0 0 12.04 2zm0 1.67c2.2 0 4.27.86 5.83 2.42a8.2 8.2 0 0 1 2.41 5.82c0 4.54-3.7 8.24-8.25 8.24a8.23 8.23 0 0 1-4.2-1.15l-.3-.18-3.12.82.83-3.04-.2-.31a8.19 8.19 0 0 1-1.26-4.38c0-4.54 3.7-8.24 8.26-8.24zm-2.6 4.2c-.15 0-.4.06-.6.29-.21.23-.8.78-.8 1.9 0 1.12.82 2.2.93 2.36.11.15 1.6 2.44 3.87 3.42.54.23.96.37 1.29.48.54.17 1.04.15 1.43.09.44-.07 1.34-.55 1.53-1.08.19-.53.19-.98.13-1.08-.06-.09-.21-.15-.44-.26-.23-.12-1.34-.66-1.55-.74-.21-.08-.36-.11-.51.11-.15.23-.58.74-.71.89-.13.15-.26.17-.49.06-.23-.12-.96-.36-1.83-1.13-.68-.6-1.13-1.35-1.27-1.57-.13-.23-.01-.35.1-.47.1-.1.23-.26.34-.4.11-.13.15-.23.23-.38.08-.15.04-.29-.02-.4-.06-.12-.51-1.23-.7-1.68-.18-.44-.37-.38-.51-.39h-.43z" />
    </svg>
  );
}
